module.exports = __webpack_public_path__ + "static/media/BEL.896364c8.svg";